import React from 'react';
import { useDispatch } from 'react-redux';
import { textSettingsChangeFontType } from '../state/controller';
import { PanelSubSectionComponent } from '../../../core/components/panel/PanelComponent';

const CustomFontContainer = () => {
  const dispatch = useDispatch();

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const reader = new FileReader();

      reader.onloadend = () => {
        const style = document.createElement('style');

        style.innerHTML = `
                    @font-face {
                        font-family: customFont;
                        src: url('${reader.result}')
                    }
                `;

        document.head.append(style);

        dispatch(textSettingsChangeFontType('customFont'));
      };

      reader.readAsDataURL(e.target.files[0]);
    }
  };

  return (
        <PanelSubSectionComponent>
            <p>Загрузите свой шрифт</p>
            <input type="file" onChange={onChange} accept=".ttf" />
        </PanelSubSectionComponent>
  );
};

export default CustomFontContainer;
